/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Tools_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not save the tool settings." |
*
* @param {Integrations_Apis_Tools_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_tools_error = /** @type {((inputs?: Integrations_Apis_Tools_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Tools_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Werkzeug-Einstellungen konnten nicht gespeichert werden.")
	return /** @type {LocalizedString} */ ("Could not save the tool settings.")
});